export default (number, prefix) => {
  const currency = String(number).split('.')

  return (prefix)
    ? prefix + currency[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    : currency[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}
